import React from "react"
import { SubmitHandler, useForm } from "react-hook-form"
import { useMutation } from "@apollo/client"
import { hideEditSidebar } from "lib/store/services/editSidebar/slice"
import { useAppDispatch } from "lib/store"
import alertActions from "lib/store/services/Alert/AlertSlice"

import CREATE_OR_UPDATE_CUSTOM_GIFT_CARD_CONFIG from "graphql/mutations/config/CreateOrUpdateCustomGiftCardConfig"

import EditSidebar from "components/Ui/EditSidebar/EditSidebar"
import EditSidebarHeader from "components/Ui/EditSidebar/EditSidebarHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import CustomGiftCardConfigInputs, {
  ExtendedInputCustomGiftCardConfig
} from "components/Config/CustomGiftCard/CustomGiftCardConfigInputs"

type Props = {
  refetch: () => void
}

export const CreateCustomGiftCardConfig = ({ refetch }: Props) => {
  const dispatch = useAppDispatch()

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<ExtendedInputCustomGiftCardConfig>({ mode: "onBlur" })

  const [addCustomGiftCardConfig, { loading }] = useMutation(
    CREATE_OR_UPDATE_CUSTOM_GIFT_CARD_CONFIG,
    {
      onCompleted: () => {
        reset({
          id: "",
          baseUrl: "",
          tokenUrl: "",
          scopes: [],
          clientId: "",
          clientSecret: ""
        })
        dispatch(hideEditSidebar())
        dispatch(
          alertActions.actions.createAlert({
            message: "Brink Custom Gift Card configuration successfully created",
            type: "success"
          })
        )
        refetch()
      },
      onError: () => {
        dispatch(
          alertActions.actions.createAlert({
            type: "error"
          })
        )
      }
    }
  )

  const onSubmit: SubmitHandler<ExtendedInputCustomGiftCardConfig> = (data) => {
    addCustomGiftCardConfig({ variables: { ...data } })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <EditSidebar>
        <EditSidebarHeader title="Create Brink Custom Gift Card configuration">
          <PrimaryButton type="submit" loading={loading}>
            Save
          </PrimaryButton>
        </EditSidebarHeader>
        <CustomGiftCardConfigInputs
          control={control}
          errors={errors}
          setValue={setValue}
          showId={true}
        />
      </EditSidebar>
    </form>
  )
}
